import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import MaterialModal from "../MaterialModal";
import withModal from "../withModal";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { deleteModelBundle, hideModal } from "../../../actions/actionCreators";
import { IAppState } from "../../../types/stores";

type Props = {
    isOpen: boolean;
};

const ModelBundleDeleteModal: React.FC<Props> = ({ isOpen }: Props) => {
    const dispatch = useDispatch();

    const [bundleId, setBundleId] = useState(0);

    const modelBundles = useSelector((state: IAppState) => state.vars.modelBundles || []);

    const getFilteredItems = () => {
        let filteredItems = modelBundles;
        filteredItems = filteredItems.filter(d => d.CanDelete);
        return filteredItems;
    };

    const modelAvailToDeleteBundles = getFilteredItems();

    const deleteModel = () => {
        dispatch(deleteModelBundle(bundleId == 0 ? modelAvailToDeleteBundles.find(d => d.CanDelete)?.value : bundleId));

        dispatch(hideModal("MODEL_BUNDLE_DELETE"));
        setBundleId(0);
    };
    const hide = () => {
        dispatch(hideModal("MODEL_BUNDLE_DELETE"));
    };

    const onBundleChange = bundleIdValue => {
        setBundleId(bundleIdValue);
    };

    const renderBundle = () => {
        let bundleSelect: JSX.Element | string = "";

        const options = modelAvailToDeleteBundles.map(company => (
            <MenuItem key={company.value} className="company-select-option" value={company.value}>
                {company.label}
            </MenuItem>
        ));

        let bundleIdNew: number | undefined = bundleId;
        if (bundleId == 0 && modelAvailToDeleteBundles.length > 0) {
            bundleIdNew = modelAvailToDeleteBundles.find(d => d.CanDelete)?.value;
        }
        bundleSelect = (
            <div className="m-t padding-bottom-sm">
                <div className="col-sm-16 text-nowrap ">
                    <div>
                        <FormControl
                            style={{
                                flexGrow: 2,
                                marginBottom: 20,
                                fontSize: 14,
                                minWidth: "400px",
                                maxWidth: "100%",
                            }}
                        >
                            <Select
                                style={{ fontSize: 20 }}
                                value={bundleIdNew}
                                onChange={e => {
                                    onBundleChange(e.target.value);
                                }}
                            >
                                {options}
                            </Select>
                        </FormControl>
                    </div>
                </div>
            </div>
        );
        return bundleSelect;
    };

    const renderModal = () => {
        let bundleName: string | undefined = "selected";
        let confirmTitle = "Delete Bundle Confirmation";
        let confirmButtonText = "Delete";
        let bundleIdSelected: number | undefined = 0;
        if (modelAvailToDeleteBundles.length > 0) {
            bundleIdSelected = bundleId == 0 ? modelAvailToDeleteBundles.find(d => d.CanDelete)?.value : bundleId;

            bundleName =
                modelAvailToDeleteBundles && modelAvailToDeleteBundles.find(d => d.value == bundleIdSelected)
                    ? modelAvailToDeleteBundles.find(d => d.value == bundleIdSelected)?.label
                    : "selected";
        }

        let confirmBody = (
            <div>
                Are you sure want to delete <strong>&quot;{bundleName}&quot;</strong> bundle?
            </div>
        );

        let modal = (
            <MaterialModal
                isOpen={isOpen}
                title="Delete Bundle"
                primaryButtonText="Delete"
                onClose={hide}
                onPrimaryButtonRequest={deleteModel}
                showPrimaryButton={true}
                id="flow-visislbe-variables"
                showConfirmModal={true}
                confirmTitle={confirmTitle}
                confirmButtonText={confirmButtonText}
                confirmBody={confirmBody}
            >
                {renderBundle()}
            </MaterialModal>
        );

        return modal;
    };

    return renderModal();
};

export default withModal(ModelBundleDeleteModal, "MODEL_BUNDLE_DELETE");
